module.exports = __webpack_public_path__ + "img/top-2-3.2e46eda9.jpg";